export default [
  {
    route: '/',
    title: 'Dashboard',
    icon: 'HomeIcon',
    i18n: 'Mural',
    rule: 'dashboard'
  }
]
